export const version = __APP_VERSION__ || "0.0.0";
